import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuOpened: false,
      upButtonVisible: false,
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', () => {this.handleScroll()});
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', () => {this.handleScroll()});
  }

  scrollTo(id) {
    this.setState({
      menuOpened: false,
    });
    document.getElementById(id).scrollIntoView();
  }

  handleScroll() {
    if (document.documentElement.scrollTop > document.getElementById("intro").getBoundingClientRect().top)
      this.setState({ upButtonVisible: true });
    else
      this.setState({ upButtonVisible: false });
  }

  render() {
    document.title = "Пленэр. Исторические ландшафты России";

    var artists = [
      {
        nameEng: "Thierry Lefort",
        nameRus: "Тьерри Лефорт",
        row1: "Государственный музей-заповедник",
        row2: "«Царское Село»",
        site: "http://www.thierrylefort.com/",
        facebook: "https://www.facebook.com/thierry.lefort.319 ",
      },
      {
        nameEng: "Laurence De Marliave",
        nameRus: "Лоранс Дэ Марлиав",
        row1: "Музей-усадьба Л.Н. Толстого",
        row2: "«Ясная Поляна»",
        site: "http://laurencedemarliave.com/ ",
        facebook: "",
      },
      {
        nameEng: "Barbara Petit",
        nameRus: "Барбара Пти",
        row1: "Центральный парк культуры и отдыха им. С.М. Кирова",
        row2: "Елагин остров",
        site: "https://barbaralisy.wordpress.com/",
        facebook: "https://www.facebook.com/barbara.petit.39",
      },
      {
        nameEng: "Olivier Desvaux",
        nameRus: "Оливье Дэво",
        row1: "Государственный музей-заповедник",
        row2: "«Ростовский Кремль»",
        site: "http://olivierdesvaux.com/",
        facebook: "https://www.facebook.com/Olivier-Desvaux-320352058158341/",
      },
      {
        nameEng: "Emily Starck",
        nameRus: "Эмили Старк",
        row1: "Историко-культурный центр",
        row2: "«Дворцовый комплекс Ольденбургских»",
        site: "http://www.emilystarck.com/",
        facebook: "https://www.facebook.com/emily.starck",
      },
      {
        nameEng: "Cyril Maurette",
        nameRus: "Сирил Морэт",
        row1: "",
        row2: "«Усадьба Марьино»",
        site: "http://www.cyrilmaurette.com/",
        facebook: "https://www.facebook.com/cyril.maurette.7",
      },
      {
        nameEng: "Céline Bokobza",
        nameRus: "Селин Бокобза",
        row1: "Государственный музей-заповедник",
        row2: "«Горки Ленинские»",
        site: "http://celinebokobza.com/",
        facebook: "https://www.facebook.com/celine.bokobza",
      },
    ];
    var artistsMapped = artists.map((artist, index) =>
      <div className="row">
        <div className={"artist-desktop artist" + (index + 1)}>
          <img src={"new/" + (index + 1) + ".png"} className={"avatar " + (index % 2 == 0 ? "left" : "right")} />
          <div className={"name " + (index % 2 == 0 ? "left" : "right")}>
            <h2>{artist.nameEng}</h2>
            <h3>{artist.nameRus}</h3>
          </div>
          <div className={"place " + (index % 2 == 1 ? "left" : "right")}>
            <h3>{artist.row1}</h3>
            <h1>{artist.row2}</h1>
          </div>
          <div className={"links " + (index % 2 == 0 ? "left text-right" : "right text-left")}>
            {artist.site ? <a href={artist.site} target="_blank">персональный сайт</a> : ""}
            {artist.facebook ? <a href={artist.facebook} target="_blank">facebook</a> : ""}
          </div>
        </div>
        <div className={"artist-mobile artist" + (index + 1)}>
          {/* <img src={"artists/" + (index + 1) + ".png"} className="avatar" />
          <img src={"pic/" + (index + 1) + "m.png"} className="avatar" />
          <img src={"paint/" + (index + 1) + ".png"} className="paint" /> */}
          <img src={"newm/" + (index + 1) + ".png"} className="newm" />
          <div className="text">
            <div className={"name "}>
              <h2>{artist.nameEng}</h2>
              <h3>{artist.nameRus}</h3>
            </div>
            <div className={"links "}>
              {artist.site ? <a href={artist.site}>персональный сайт</a> : ""}
              {artist.facebook ? <a href={artist.facebook}>facebook</a> : ""}
            </div>
            <div className={"place "}>
              <h3>{artist.row1}</h3>
              <h1>{artist.row2}</h1>
            </div>
          </div>
        </div>
      </div>
    );

    var schedule = [
      {
        date: <div className="row"><p className="date">5 - 22</p><p className="month">апреля</p></div>,
        place: "Центральный парк культуры и отдыха им. С.М. Кирова",
        place2: "Елагин остров",
        place3: "Санкт-Петербург",
      },
      {
        date: <div className="row"><p className="date">22</p><p className="month">апреля</p><p className="date">– 20</p><p className="month">мая</p></div>,
        place: "усадебный комплекс строгановых - голицыных",
        place2: "усадьба марьино",
        place3: "ленинградская область",
      },
      {
        date: <div className="row"><p className="date">28</p><p className="month">мая</p><p className="date"> - 24</p><p className="month">июня</p></div>,
        place: "государственный музей-заповедник",
        place2: "царское село",
        place3: "Санкт-Петербург",
      },
      {
        date: <div className="row"><p className="date">5 - 29</p><p className="month">июля</p></div>,
        place: "Музей-усадьба Л.Н. Толстого",
        place2: "ясная поляна",
        place3: "тульская область",
      },
      {
        date: <div className="row"><p className="date">3 - 26</p><p className="month">августа</p></div>,
        place: "Историко-культурный центр",
        place2: "Дворцовый комплекс Ольденбургских",
        place3: "воронежская область",
      },
      {
        date: <div className="row"><p className="date">3</p><p className="month">сентября</p></div>,
        place: "государственный музей-заповедник",
        place2: "Ростовский кремль",
        place3: "ростов великий",
      },
      {
        date: <div className="row"><p className="date">6</p><p className="month">октября</p></div>,
        place: "государственный музей-заповедник",
        place2: "горки ленинские",
        place3: "московская область",
      },
    ];
    var scheduleMapped = schedule.map((event, index) =>
      <div className={"event event" + (index + 1)}>
        {event.date}
        <p className="place">{event.place}</p>
        <p className="place2">{event.place2}</p>
        <p className="place3">{event.place3}</p>
      </div>
    );

    return (
      <div>
        <div id="header">
          <div className={"links-menu " + (this.state.menuOpened ? "" : "hidden")}>
            <div class="blured"></div>
            <div className="links-column">
              <button className="menu" onClick={() => this.setState({ menuOpened: !this.state.menuOpened })}></button>
              <button className="link" onClick={() => this.scrollTo("artists")}>художники</button>
              <button className="link" onClick={() => this.scrollTo("exibitions")}>выставки</button>
              <button className="link" onClick={() => this.scrollTo("footer")}>пресс-релиз</button>
              <button className="link" onClick={() => this.scrollTo("footer")}>контакты</button>
            </div>
          </div>
          <div className="mobile-links">
            <button className="menu" onClick={() => this.setState({ menuOpened: !this.state.menuOpened })}></button>
          </div>
          <div className="container">
            <div className="links">
              <button className="link" onClick={() => this.scrollTo("footer")}>контакты</button>
              <button className="link" onClick={() => this.scrollTo("footer")}>пресс-релиз</button>
              <button className="link" onClick={() => this.scrollTo("exibitions")}>выставки</button>
              <button className="link" onClick={() => this.scrollTo("artists")}>художники</button>
            </div>
            <div className="row">
              <div className="logo"></div>
            </div>
            <div className="row text-right with-margin">
              <h2>Пленэр.</h2>
              <h2>Исторические</h2>
              <h2>ландшафты</h2>
              <h2>России</h2>
            </div>
            <div className="row bottom">
              <p className="with-margin">При поддержке:</p>

              <p>Посольство Российской</p>
              <p className="with-margin">Федерации во Франции</p>

              <p>Фонд Садов и Парков</p>
              <p className="with-margin">Франции</p>
            </div>
          </div>
        </div>

        <div id="intro">
          <div className="container">
            <div className="row">
              <div className="left-half">
                <h1>7</h1>
              </div>
              <div className="right-half">
                <h3>исторических парков</h3>
                <h3>французских художников</h3>
              </div>
            </div>
            <div className="row">
              <img src="paint/intro.png" />
            </div>
            <div className="desktop">
              <p>Национальная ассоциация «Возрождение исторических садов и парков» пригласила </p>
              <p>7 французских художников для создания живописных работ на пленере. Осенью </p>
              <p>2017 года художники работали в семи исторических парках России, входящих </p>
              <p>в состав Ассоциации. В 2018 году в рамках передвижной выставки</p>
              <p>35 картин будут представлены во всех музеях-участниках проекта.</p>
              <p>В 2019 году при поддержке наших партнеров планируется</p>
              <p>организовать выставки во Франции.</p>
            </div>
            <div className="mobile">
              <p>
                Национальная ассоциация «Возрождение исторических садов и парков» пригласила 7 французских художников для создания живописных работ на пленере. Осенью
                2017 года художники работали в семи исторических парках России, входящих
                в состав Ассоциации. В 2018 году в рамках передвижной выставки
                35 картин будут представлены во всех музеях-участниках проекта.
                В 2019 году при поддержке наших партнеров планируется
                организовать выставки во Франции.
              </p>
            </div>
          </div>
        </div>

        <div id="artists">
          <div className="container">
            {artistsMapped}
          </div>
        </div>

        <div id="exibitions">
          <div class="container">
            <div className="left-half">
              <h1>Выставки в Росcии в&nbsp;2018 году</h1>
              {scheduleMapped}
            </div>
            <div className="right-half"></div>
          </div>
        </div>

        <div id="footer">
          <div className="container">
            <div className="half">
              <div className="half2">
                <h1>
                  Пленэр.
                </h1>
                <h1>
                  Исторические
                </h1>
                <h1>
                  ландшафты
                </h1>
                <h1>
                  России
                </h1>
              </div>
              <div className="half2">
                <p>
                  национальная
                </p>
                <p>
                  ассоциация
                </p>
                <p>
                  «Возрождение
                </p>
                <p>
                  исторических
                </p>
                <p>
                  садов и парков»
                </p>
              </div>
            </div>
            <div className="half">
              <div className="half2">
                <p>
                  пресс-релиз
                </p>
                <a href="/PleinAir_press.rar" download>
                  скачать
                </a>
                <a href="/PleinAir_press.rar" download>
                  пресс-релиз
                </a>
                <a href="/PleinAir_press.rar" download>
                  и материалы
                </a>
                <a href="/PleinAir_press.rar" download>
                  к проекту
                </a>
              </div>
              <div className="half2">
                <p>
                  контакты
                </p>
                <p>
                  по всем вопросам:
                </p>
                <p>
                  Екатерина гомазкова
                </p>
                <p>
                  +7 921 886 46 94
                </p>
                <p>
                  higardens@mail.ru
                </p>
              </div>
            </div>
          </div>
        </div>
        <button className={this.state.upButtonVisible ? "up" : "up invisible"} onClick={() => this.scrollTo("header")}>
          <div className="arrow-up"></div>
          <p>наверх</p>
        </button>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Home.js